import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import Paper from '@material-ui/core/Paper';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';

const StyledTableCell = withStyles({
  head: {
    backgroundColor: 'white',
    color: '#013957',
    fontWeight: 'bold',
    borderBottom: '0.5px solid #c1c1c1',
    '&:first-child': {
      paddingLeft: 16,
    },
    '&:last-child': {
      paddingRight: 16,
    },
  },
  body: {
    fontSize: 14,
    fontWeight: (props) => (props.fontWeight ? props.fontWeight : 'normal'),
    color: (props) => (props.color ? props.color : '#484848'),
    fontStyle: (props) => (props.fontStyle ? props.fontStyle : 'normal'),
    borderBottom: 'none',
    '&:first-child': {
      paddingLeft: 16,
    },
    '&:last-child': {
      paddingRight: 16,
    },
  },
})(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(even)': {
      backgroundColor: '#f6f8fb',
    },
  },
  hover: {
    color: '#e7e7e7',
    cursor: 'pointer',
  },
}))(TableRow);

const columns = [
  'Reg.',
  'Nombre completo',
  'Correo electrónico',
  'Tipo de membresía',
  'Estado de membresía',
  'Área de práctica',
  '',
];

const useStyles = makeStyles({
  tableContainer: {
    boxShadow: 'none',
  },
  table: {
    minWidth: 700,
  },
  download: {
    color: '#10587f',
    textDecoration: 'none',
    cursor: 'pointer',
  },
});

const LawyerList = ({ allLawyers, handleShowDetailLawyer }) => {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div style={{ maxWidth: 1024, margin: '0 auto' }}>
        <TableContainer
          component={Paper}
          classes={{ root: classes.tableContainer }}
        >
          <Table
            className={classes.table}
            aria-label="customized table"
            padding="default"
          >
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <StyledTableCell key={index}> {column} </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {allLawyers && allLawyers.data.map((row, index) => (
                <StyledTableRow 
                    key={index} 
                    hover 
                    onClick={() => handleShowDetailLawyer(true, row.uid)}
                >
                  <StyledTableCell>
                    <img src="/img/avatars/contacta-circle.svg" alt="avatar" />
                  </StyledTableCell>
                  <StyledTableCell>
                    {row.name + ' ' + row.firstLastName}
                  </StyledTableCell>
                  <StyledTableCell>{row.email}</StyledTableCell>
                  <StyledTableCell>{row.membership.type}</StyledTableCell>
                  <StyledTableCell>Activa</StyledTableCell>
                  <StyledTableCell>{row.specialties[0]}</StyledTableCell>
                  <StyledTableCell>
                    <img src="/img/arrows/arrow-right.svg" alt="ver detalle" />
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 15]}
                  colSpan={3}
                  count={allLawyers.totalItems}
                  rowsPerPage={rowsPerPage}
                  page={allLawyers.actualpage}
                  SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                  }}
                  //onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  //ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default LawyerList;
